import { useEffect, useRef } from 'react';
import { useLazyQuery } from '@apollo/client';
import { GET_VEHICLE_AND_MODEL_BY_DRIVER_ID, GetVehicleAndModelByDriverIdResponse } from '../schedule/graphql/queries/getVehicleAndModelByDriverId';

export interface UseTmsVehicleAndModelCallbacks {
  onVehicleAndModelFound: (vehicleId: number, vehicleModelName: string, vehicleModelId: number, vehicle: { id: number; licensePlate?: string; vehicleNumber?: string }, vehicleTypeId?: number) => void;
  onVehicleAndModelNotFound: () => void;
  onError?: (error: any) => void;
}

/**
 * TMS车辆和车型查询Hook
 * 根据司机ID查询绑定的车辆和车型信息
 */
export const useTmsVehicleAndModel = (callbacks: UseTmsVehicleAndModelCallbacks) => {
  const callbacksRef = useRef(callbacks);
  callbacksRef.current = callbacks;

  const [getVehicleAndModel, { data, error, loading: loadingVehicleModel }] = useLazyQuery<GetVehicleAndModelByDriverIdResponse>(
    GET_VEHICLE_AND_MODEL_BY_DRIVER_ID
  );

  useEffect(() => {
    if (data === undefined) return;
    if (data?.getVehicleAndModelByDriverId) {
      const { vehicleId, vehicleModelId, vehicleTypeId, vehicleTypeName, vehicle } = data.getVehicleAndModelByDriverId;
      callbacksRef.current.onVehicleAndModelFound(
        vehicleId,
        vehicleTypeName ?? '',
        vehicleModelId,
        {
          id: vehicleId,
          licensePlate: vehicle?.licensePlate,
          vehicleNumber: vehicle?.vehicleNumber
        },
        vehicleTypeId != null ? Number(vehicleTypeId) : undefined
      );
    } else {
      callbacksRef.current.onVehicleAndModelNotFound();
    }
  }, [data]);

  useEffect(() => {
    if (!error) return;
    console.error('Failed to fetch vehicle and model:', error);
    if (callbacksRef.current.onError) {
      callbacksRef.current.onError(error);
    } else {
      callbacksRef.current.onVehicleAndModelNotFound();
    }
  }, [error]);

  return {
    getVehicleAndModel,
    loadingVehicleModel
  };
};
